<template>
  <div class="line-item">           
      <div class="heading ml-2" style="display:flex;" @click.stop.prevent="$store.myActions.UI_SET_MEASURETOOL('NONE');">           
        <v-btn class="mx-0" small icon @click.prevent="toggleSimulationVisibility(simulation.simulation.id)" :title="$t(simulationMapVisibility[simulation.simulation.id]?'Pilot.MissionDrawer.HideMissionTooltip':'Pilot.MissionDrawer.ShowMissionTooltip')"><v-icon>{{simulationMapVisibility[simulation.simulation.id]?'mdi-eye':'mdi-eye-off'}}</v-icon></v-btn>        
        <v-btn v-if="simulation.misVirtual" class="missionbtn mx-0 pr-2" :class="{'red--text darken-3':isError}" flat @click.prevent="toggleSimulationDetailVisibility(simulation)"  :title="$t(simulationDetailVisibility[simulation.simulation.id]?'Pilot.MissionDrawer.HideMoreMissionInfosTooltip':'Pilot.MissionDrawer.ShowMoreMissionInfosTooltip')" >
          <v-progress-circular v-if="isRunning" class="mr-2" :rotate="360" indeterminate color="primary" :size="18" :width="2" ></v-progress-circular> 
           {{ simulation.simulation.MIG_LIBELLE }} <!--#{{ simulation.misVirtual.VIM_ITERATION.toString().padStart(2,'0') }}           -->
          <v-icon   :class="{rotate180:simulationDetailVisibility[simulation.simulation.id]}" style="margin-left:auto">mdi-chevron-down</v-icon>
        </v-btn>  
        <template v-else>
          <div class="grow pl-3">{{ simulation.simulation.MIG_LIBELLE }}</div>        
        </template>                      
        <v-btn class="mx-0" v-if="simulation.misVirtual" small icon v-show="simulationMapVisibility[simulation.simulation.id]" @click.prevent="$store.myActions.UI_SELECT_SIMULATION_MAP({id:simulation.misVirtual.id,uiid:map_uiid})" :title="$t('Pilot.MissionDrawer.SelectMissionTooltip')"><v-icon :class="{active:simulation.misVirtual.id == bestFitMisId}">mdi-crosshairs-gps</v-icon></v-btn>        
        <mission-color v-if="simulation.misVirtual && $vuetify.breakpoint.name != 'xs'"  class="mx-0" v-show="simulationMapVisibility[simulation.simulation.id]" :uiid="`mission_${simulation.misVirtual.id}_global`" :mapUiid="uiid" :mission="simulation.misVirtual.mission"  />                
        <v-btn class="mx-0" @click.stop.prevent="deleteMissionGlobal" small icon :title="$t('Pilot.MissionDrawer.SelectMissionTooltip')"><v-progress-circular class="ml-2"  :size="20" v-if="deleting" indeterminate color="white"></v-progress-circular><v-icon v-else>mdi-delete</v-icon></v-btn>        
        <v-btn class="mx-0" small icon flat :to="{name:'SmartPlanningDetail',params:{simulationid:simulation.simulation.id}}" :title="$t('Simulation.ReachSimulationPageTooltip')" ><v-icon>mdi-forward</v-icon></v-btn>
      </div>      
      <v-expand-transition>                
        <simulation-mission-line-detail  class="mx-1 mb-2 px-2 pb-2 pt-0" v-if="simulationDetailVisibility[simulation.simulation.id] && simulation.misVirtual" :mission="simulation.misVirtual" typeUiid="global" />             
      </v-expand-transition>
  </div> 
</template>
<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'
import { buildSimulationUIStateId,SimulationUiState } from '@/models/ui/SimulationUiState'
import { MapUiState } from '@/models/ui/MapUiState'
import { AloDbMissionGlobal } from '@/models/alodb/AloDbMissionGlobal'
import { AloDbMissionVirtual } from '@/models/alodb/AloDbMissionVirtual'
import SimulationMissionLineDetail from '@/components/smart/SimulationMissionLineDetail.vue'
import MissionColor from '@/components/mission/MissionColor.vue'
import { VuetifyConfirmObject } from 'vuetify-confirm'

@Component({
    name: 'MainSimulationLine',  
    props:{  
      simulation:{
        type:Object,
        required:true
      }
    },
    components:{SimulationMissionLineDetail,MissionColor}
})
export default class MainSimulationLine extends Vue {      

  deleting = false

  simulation!:{
    simulation:AloDbMissionGlobal,
    misVirtual:AloDbMissionVirtual|null
  }

  get simulationMapVisibility() {
    return this.$store.myGetters.simulationMapVisibility
  }

  toggleSimulationVisibility(simId:number) {
    if(!this.simulationMapVisibility[simId])  {
      this.$set(this.simulationMapVisibility,simId,true)
    }
    else{
      this.simulationMapVisibility[simId] = !this.simulationMapVisibility[simId]
    }
  }

  get simulationDetailVisibility() {
    return this.$store.myGetters.simulationDetailVisibility
  }  

  get missionDetailVisibility() {
    return this.$store.myGetters.missionDetailVisibility
  }    

  toggleSimulationDetailVisibility(simulation:{
    simulation:AloDbMissionGlobal,
    misVirtual:AloDbMissionVirtual|null
  }) {
    const simId = simulation.simulation.id!
    const vimId = simulation.misVirtual?.id!
    //this.$store.myActions.TOGGLE    
    if(!this.simulationDetailVisibility[simId])  {       
      this.$set(this.simulationDetailVisibility,simId,true)      
    }
    else{         
      this.simulationDetailVisibility[simId] = !this.simulationDetailVisibility[simId]      
    }
    if(vimId) this.$set(this.missionDetailVisibility,vimId,this.simulationDetailVisibility[simId])      
    if(!(simulation?.misVirtual?.mission?._detailLoaded ?? false)) {
      this.$store.myActions.MISSIONVIRTUAL_PROGRESSION_REQUEST(vimId)
    }   
  }  


  uiid:string = "map_global"
  mission!:AloDbMissionVirtual

  get uistatebyuiid(){
    return this.$store.myGetters.uistatebyuiid
  }

  get isRunning(){
    //TODO ameliorer avec enum
    return this.simulation.misVirtual && (this.simulation.misVirtual?.result?.simulation_state == 'running' || (( this.simulation.misVirtual?.result?.simulation_state?.length ?? 0) == 0 && this.simulation.misVirtual.VIM_STATUS >= 0 && this.simulation.misVirtual.VIM_STATUS != 10))    
  }
  
  get missionState() {  
    //retourne un MissionUiState                
    return this.uistatebyuiid(this.uiid)
  }

  get simulation_uiid() {
    return buildSimulationUIStateId(this.simulation.simulation.MIG_ID!,"detail")
  }

  get map_uiid() {
    return "map_global"
  }

  get mapState() { 
    //retourne un MapUiState    
    return this.uistatebyuiid(this.map_uiid) as MapUiState         
  }

  get bestFitMisId(){
    return this.mapState?.bestFitMisId
  }
    
  get isError(){
    return (this?.simulation.misVirtual?.result?.error_msg?.length ?? 0) > 0
  }
    
  get accesPilotReachDetail() {
    return true
  }


  async deleteMissionGlobal() {
    if(!this.deleting) {
      const answer = await this.$confirm(this.$t('Simulation.DeleteMissionDialogMessage',{name:this.simulation.simulation.MIG_LIBELLE}).toString(),{title: this.$t('Admin.Warning')} as VuetifyConfirmObject)
      if (answer) {
        //@ts-ignore
        this.deleting = true
        try{
          await this.$store.myActions.MISSIONGLOBAL_DELETE_REQUEST(this.simulation.simulation)
        }
        finally{
          this.deleting = false
        }        
      }    
    }
  }

}

</script> 

<style>

.rotate180{
  transform: rotate(-180deg);
}

.missionbtn .v-icon{
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1)!important;
}

.testMission{
  font-style: italic;
  color: rgb(128, 128, 128)!important;
}

.line-item{
  border-bottom: 1px solid #eee;
}
.line-item .active{
  color: #4caf50!important;  
}

.line-item .heading{
  display: flex;
  flex-direction: row;
  align-items: center;  
}

.missionbtn{
  flex:1 0 auto;
}

.missionbtn .v-btn__content{
  justify-content: flex-start;
}

</style>